export default __webpack_public_path__ + "static/media/project_github.f04a7ddc.WebP";